const en = {
  zh: "中文",
  en: "English",

  SAVE: "Save",

  home: "Homepage",
  onlineshow: "Product",
  business: "Company",
  business1: "Company",
  artilce1: "Artilce",
  exhibit: "Exhibit",
  artilce: "Information",
  contact: "Contract",

  HOMEPAGE: "HOMEPAGE",
  PRODUCT: "PRODUCT",
  COMPANY: "COMPANY",
  INFORMATION: "INFORMATION",
  CONTRACT: "CONTRACT",
  MEETING: "MEETING",
  EXHIBITOR: "EXHIBITOR",

  "Search keywords...": "Please input the company name and booth number",
  onlineAboutUs: "About Us",
  signInMajuscule: "Sign In/Join Free",
  console: "Console",
  joinFreeMajuscule: "JION FREE",
  Hotline: "Hotline",
  "For Suppliers": "For Suppliers",
  "For Buyers2": "For Buyers",
  Favorites: "Favorites",
  Massage: "Massage",
  Application: "参展报名",
  "Scan this": "Scan this",
  Search: "Search",
  "Search company or product or news…": "Search company or product or news…",
  "21st floor, No.1678 Jinshajiang Road, Shanghai200333 ":
    "21st floor, No.1678 Jinshajiang Road, Shanghai200333",
  "Publish Transaction2": "Publish Transaction",
  Inquiry: "Inquiry",
  Inquiry1: "Inquiry",
  Favorite: "Favorite",
  Favorited: "Favorited",
  "Hot Products": "Hot Products",
  Products: "Products",
  Reservation: "Reservation",
  More: "More",
  "About Us": "About Us",
  "Hotline:Working days，AM 9:00-PM 5:00":
    "Hotline:Working days，AM 9:00-PM 5:00",
  "Hotline:021-32513000": "Hotline:021-32513000",
  "Send Massage": "Send Massage",
  "Please Enter Your E-Mail！": "Please Enter Your E-Mail！",
  "Scan this to mobile website": "Scan this to mobile website",
  "Contact Us": "Contact Us",
  "For Buyers": "For Buyers",
  "For Suppliers": "For Suppliers",
  "Media Cooperation": "Media Cooperation",
  "Online Exhibition": "Online Exhibition",
  Download: "Download",
  "Submit & Continue": "Submit & Continue",
  Subscription: "Subscription",
  "All Company": "All Company",
  Hall: "Hall",
  AddFavorites: "AddFavorites",
  "Company Details": "Company Details",
  "Product Introduction": "Product Introduction",
  "Product Parameters": "Product Parameters",
  "Company Details2": "Company Details",
  "Contact Information": "Contact Information",
  "Product Name": "Product Name",
  "Product Color": "Product Color",
  "Product Material": "Product Material",
  "Product Size": "Product Size",
  "Product Type": "Product Type",
  Recommendation: "Recommendation",
  "More Proudct…": "More Proudct…",
  "Business Content": "Business Content",
  "Share To": "Share To",
  "Reference Price": "Reference Price",
  "Company Address": "Company Address",
  "Send Invitation": "Send Invitation",
  "Products List": "Products List",
  "Find us in Exhibition": "Find us in Exhibition",
  "Products List": "Products List",
  "Send Invitation2": "Send Invitation",
  "Contact Company2": "Contact Company",
  "Send Inquiry": "Send Inquiry",
  "Join Free": "Join Free",
  "Join Free2": "Join Free",
  Homepage: "Homepage",
  "Sign in Now": "Sign in Now",
  "Have an Account": "Have an Account",
  "Products Category": "Products Category",
  Default: "Default",
  Latest: "Latest",
  Password: "Exhibitor",
  placeholder_password: "Password",
  placeholder_username: "Exhibitor",
  Mobile: "Audience",
  "New User": "Email Login",
  "Join Free3": "Join Free3",
  Verification: "Verification",
  "Send Code": "Send Code",
  "Verification Code": "Verification Code",
  "Auto Login Next Time": "Auto Login Next Time",
  "Forget Password": "Forget Password",
  Password2: "Password",

  "Complete Bikes": "Complete Bikes",
  Unicycles: "Unicycles",
  Scooter: "Scooter",
  "Children's Vehicles": "Children's Vehicles",
  Trailers: "Trailers",
  Bicycles: "Bicycles",
  "Folding Bicycles": "Folding Bicycles",
  "Frames,Forks & Parts": "Frames,Forks & Parts",
  Seatpost: "Seatpost",
  "Shock Absorbers,Suspension System": "Shock Absorbers,Suspension System",
  Frames: "Frames",
  "Head Parts": "Head Parts",
  "Lugs & Shells ": "Lugs & Shells ",
  "Steel Ball Nest": "Steel Ball Nest",
  "Front Forks": "Front Forks",
  "Rear Ends/Dropouts ": "Rear Ends/Dropouts ",
  "Spindle/Shaft ": "Spindle/Shaft ",
  "Tires,Rims & Parts": "Tires,Rims & Parts",
  Tirefit: "Tirefit",
  "Repair Kits/Rubber Solutions": "Repair Kits/Rubber Solutions",
  Valves: "Valves",
  "Spokes & Nipples": "Spokes & Nipples",
  Hubs: "Hubs",
  Rims: "Rims",
  Wheelset: "Wheelset",
  "Tires/Inner Tubes": "Tires/Inner Tubes",
  "Plastic Wheels": "Plastic Wheels",
  "Transmissions & Parts": "Transmissions & Parts",
  "Freewheels/Sprockets": "Freewheels/Sprockets",
  Chains: "Chains",
  "Chainwheels & Cranks": "Chainwheels & Cranks",
  "Steering & Components": "Steering & Components",
  Saddles: "Saddles",
  "Handlerbars & Stem": "Handlerbars & Stem",
  "Derailleur Gear Units": "Derailleur Gear Units",
  Brakes: "Brakes",
  "Control Cables & Parts": "Control Cables & Parts",
  Pedals: "Pedals",
  Pegs: "Pegs",
  "Quick Release": "Quick Release",
  "Nuts & Bolts": "Nuts & Bolts",
  "Brake Pads": "Brake Pads",
  "Brake Line": "Brake Line",
  Stems: "Stems",
  Accessories: "Accessories",
  "Child Seat/Luggage Carriers ": "Child Seat/Luggage Carriers ",
  "Bells/Air Horns": "Bells/Air Horns",
  "Reflectors/Back Mirrors": "Reflectors/Back Mirrors",
  "Chain Covers/Fenders/Mudguards": "Chain Covers/Fenders/Mudguards",
  "Dynamo Lighting Sets/Battery Lighting ":
    "Dynamo Lighting Sets/Battery Lighting ",
  "Locks/Alarms": "Locks/Alarms",
  "Bicycle Decals": "Bicycle Decals",
  Painting: "Painting",
  Baskets: "Baskets",
  "Grips/Tapes": "Grips/Tapes",
  "Machinery & Tools": "Machinery & Tools",
  "Inspection Center": "Inspection Center",
  Tools: "Tools",
  Machinery: "Machinery",
  "Cycling/Outdoor Products": "Cycling/Outdoor Products",
  Bags: "Bags",
  Pumps: "Pumps",
  "Cycle Computer": "Cycle Computer",
  "Kettle Rack": "Kettle Rack",
  Helmet: "Helmet",
  "Carrying Frame": "Carrying Frame",
  "Sound/Electronic Products ": "Sound/Electronic Products ",
  "Gps Navigation": "Gps Navigation",
  "Non-Slip Elastic Band": "Non-Slip Elastic Band",
  "Protecitve Gear": "Protecitve Gear",
  "Plus Material ": "Plus Material ",
  "Cycling Clothes": "Cycling Clothes",
  "Cycling Gloves": "Cycling Gloves",
  "Riding Scarf/Mask": "Riding Scarf/Mask",
  "Cycling Shoes": "Cycling Shoes",
  "Cycling Glasses": "Cycling Glasses",
  "The Cycling Equipment": "The Cycling Equipment",
  "Lubricating Oil/Cleaning Agen": "Lubricating Oil/Cleaning Agen",
  Kettle: "Kettle",
  "Socks/Functional Socks": "Socks/Functional Socks",
  Camera: "Camera",
  "Electric Bicycle / Motorcycle": "Electric Bicycle / Motorcycle",
  "Electric Bicycle": "Electric Bicycle",
  "Electric Scooter": "Electric Scooter",
  "Charger/Controller": "Charger/Controller",
  Battery: "Battery",
  "Components & Parts Of E-Bike": "Components & Parts Of E-Bike",
  Motors: "Motors",
  "Detecting Equipment Of E-Bikes": "Detecting Equipment Of E-Bikes",
  "Motor Cycle": "Motor Cycle ",
  "Motor Parts": "Motor Parts",
  "Motor Cycle/Motor Parts": "Motor Cycle/Motor Parts",
  Miscellaneous: "Miscellaneous",
  Miscellaneous2: "Miscellaneous",
  Trader: "Trader",
  Trade: "Trade",
  "Media/Government": "Media/Government",
  "Industry News": "Industry News",
  "Cyclist's Home": "Cyclist's Home",
  "Industry Policy": "Industry Policy",
  "Industry History": "Industry History",
  Video: "Video",
  "Exhibition News": "Exhibition News",
  "All Information": "All Information",
  "Contact ChinaCycle": "Contact ChinaCycle",

  "W1 International Brands": "W1 International Brands",
  "W2 Bicycles & Accessories": "W2 Bicycles & Accessories",
  "W3 Children’s Bikes": "W3 Children’s Bikes",
  "E1 Bicycles": "E1 Bicycles",
  "E2 Accessories": "E2 Accessories",
  "E3 Accessories": "E3 Accessories",
  "E4 Cycling & Outdoor Sporting": "E4 Cycling & Outdoor Sporting",
  "E5 Tires / E-bikes": "E5 Tires / E-bikes",
  "E6 E-bikes & Accessories": "E6 E-bikes & Accessories",
  "E7 E-bikes & Accessories": "E7 E-bikes & Accessories",

  Exit: "Exit",

  Liked: "Liked",
  Like: "Like",

  "Contact Us": "Contact Us",

  "Product ... in total": "Product {total} in total",

  "Product Introduction 1": "Product Introduction",
  Title: "Title",
  "Products Category2": "Products Category",
  "Delivery Period": "Delivery Period",
  Name: "Name",
  Company1: "Company",
  "Job Title": "Job Title",
  "Country/Region": "Country/Region",
  Interest: "Interest",
  "Mobile/E-mail": "Mobile/E-mail",
  "Confirm Password": "Confirm Password",
  "I Agree": "I Agree",
  "Please enter your Mobile or E-mail": "Please enter your Mobile or E-mail",
  "Send Code": "Send Code",
  "Please drag the slider to the right side":
    "Please drag the slider to the right side",
  "Please enter your Name": "Please enter your Name",
  "Please enter your Company": "Please enter your Company",
  "Please enter your Job Title": "Please enter your Job Title",
  "Verification Code2": "Verification Code",
  "Please leave your description so that the enterprise can confirm the reservation information with you!":
    "Please leave your description so that the enterprise can confirm the reservation information with you!",
  "Send To": "Send To",
  "Inquiry Product": "Inquiry Product",
  "Inquired Quantity": "Inquired Quantity",
  "Estimated Order Time": "Estimated Order Time",
  "Trade Content": "Trade Content",
  "Contact Information": "Contact Information",
  "Plese Choose Inquired Quantity": "Plese Choose Inquired Quantity",
  "Your Company": "Your Company",
  "Publish Transaction": "Publish Transaction",
  "Contact Company": "Contact Company",
  "Your Name": "Your Name",
  "Your Mobile": "Your Mobile",
  "Your E-mail": "Your E-mail",

  "Year/Month/Day": "Year/Month/Day",
  "Mr./Ms.": "Mr./Ms.",
  "Your Phone": "Phone",
  "Your E-mail": "E-mail",
  SUBMIT: "SUBMIT",
  Contact: "Contact",
  "Contact Title": "Contact Title",
  "Contact Phone": "Contact Phone",
  "Contact E-mail": "Contact E-mail",
  "Company Website": "Company Website",
  "Company QRCode": "Company QRCode",
  Phone: "Phone",
  Username: "Username",
  email: "E-mail",
  confirmPassword: "confirm password",
  "Company Type": "Company Type",
  "Please choose  your Company Type": "Please choose  your Company Type",
  "Please enter your Password": "Please enter your Password",
  "Please enter your Password again": "Please enter your Password again",
  "About Us Content":
    "China Cycle Online is committed to building an online trade platform for the global bicycle industry, a new exhibition model for exhibitors and visitors and also a strong support for China Cycle Show. Through O2O, we are going to provide exhibitors with an all-year-round online display space, build an information portal for trade buyers to obtain industry information quickly, so as to accelerate the trade match between the supply and demand sides. ",
  ChinaCycle: "ChinaCycleOnline",
  Country: "Country",
  Region: "Region",
  "Please choose Products Category": "Please choose Products Category！",
  MeetingList: "Meeting List",
  RecommendMeeting: "Recommend Meeting",
  RecentMeeting: "Recent Meeting",
  MeetingMore: "More",
  readingMore: "More>>"
};
export default en;



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js